import apiService from '../apiService';

const NOTIFICATION_URL = 'notifications'
const notificationService = {
  
    async getAllNotifications(params = {}) {
        try {
            const response = await apiService.get(`/${NOTIFICATION_URL}`, { params });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async markNotificationAsRead(id) {
        try {
            const response = await apiService.post(`/${NOTIFICATION_URL}/${id}/read`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async markAllNotificationAsRead() {
        try {
            const response = await apiService.get(`/${NOTIFICATION_URL}/all/markAsRead`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // this is test api for socket notification
    async getNotificaitonFromSocket(payload) {
        try {
            const response = await apiService.post(`/notification-private`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    async testSocketConnection(payload) {
        try {
            const response = await apiService.post(`/reverb-test`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

};

export default notificationService;
